import React, { useState } from 'react';
import { contactInfo } from '../../data/ultimateData';

const UltimateFooter = () => {
 const [showTerms, setShowTerms] = useState(false);

 const scrollToForm = () => {
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 const scrollToSection = (id) => {
 const el = document.getElementById(id);
 if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
 };

 const services = [
 "काला जादू निवारण", "वशीकरण सिद्धि", "धन प्राप्ति साधना",
 "संतान प्राप्ति", "प्रेम-विवाह समाधान", "शत्रु नाश"
 ];

 const quickLinks = [
 { label: "होम", id: "hero-section" },
 { label: "परिचय", id: "about-section" },
 { label: "समस्याएं", id: "problems-section" },
 { label: "सेवाएं", id: "services-section" },
 { label: "संपर्क", id: "contact-form-section" },
 ];

 return (
 <footer className="relative" style={{ background: 'linear-gradient(180deg, #3d0c0c 0%, #2d0a0a 100%)' }} data-testid="footer">
 
 {/* Top CTA Strip - Purple & Gold */}
 <div className="bg-gradient-to-r from-[#d4a84b] via-[#d4a84b] to-[#d4a84b] py-4">
 <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-center gap-4">
 <p className="text-black font-bold text-lg" style={{ fontFamily: "'Rozha One', serif" }}>
 अभी माता मलीहा की पर्ची लगाएं!
 </p>
 <button 
 onClick={scrollToForm}
 className="px-6 py-2 bg-red-900 text-[#F3EDE2] font-bold rounded-full hover:bg-red-900 transition-all"
 >
 जांच करवाएं →
 </button>
 </div>
 </div>

 {/* Main Footer */}
 <div className="container mx-auto px-4 py-12">
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
 
 {/* About */}
 <div>
 <h3 className="text-xl font-bold " style={{ fontFamily: "'Rozha One', serif" }}>
 माता मलीहा
 </h3>
 <p className="text-[#D8D2C6]/80 text-sm mb-4">
 25+ वर्षों की कठोर साधना से प्राप्त दिव्य शक्तियों से हर समस्या का अचूक समाधान।
 </p>
 <div className="flex gap-3">
 <span className="px-3 py-1 rounded-full text-xs bg-[#250808] text-[#E2C170]">97% सफलता</span>
 <span className="px-3 py-1 rounded-full text-xs bg-[#0B0B0E] text-[#F3EDE2]">50K+ भक्त</span>
 </div>
 </div>

 {/* Services */}
 <div>
 <h3 className="text-lg font-bold text-[#D8D2C6] mb-4">सेवाएं</h3>
 <ul className="space-y-2">
 {services.map((service, i) => (
 <li key={i}>
 <button onClick={scrollToForm} className="text-[#D8D2C6]/80 text-sm hover:text-[#F3EDE2] transition-colors">
 ❖ {service}
 </button>
 </li>
 ))}
 </ul>
 </div>

 {/* Quick Links */}
 <div>
 <h3 className="text-lg font-bold text-[#D8D2C6] mb-4">Quick Links</h3>
 <ul className="space-y-2">
 {quickLinks.map((link, i) => (
 <li key={i}>
 <button onClick={() => scrollToSection(link.id)} className="text-[#D8D2C6]/80 text-sm hover:text-[#F3EDE2] transition-colors">
 → {link.label}
 </button>
 </li>
 ))}
 <li>
 <button onClick={() => setShowTerms(!showTerms)} className="text-[#D8D2C6]/80 text-sm hover:text-[#F3EDE2] transition-colors">
 → नियम व शर्तें
 </button>
 </li>
 </ul>
 </div>

 {/* Contact */}
 <div>
 <h3 className="text-lg font-bold text-[#D8D2C6] mb-4">संपर्क</h3>
 <div className="space-y-3">
 <div className="p-3 rounded-lg bg-[#0B0B0E] border border-[#d4a84b]/60">
 <p className="text-[#F3EDE2] text-sm font-bold">केवल फॉर्म द्वारा संपर्क</p>
 <p className="text-[#D8D2C6]/70 text-xs mt-1">अपनी समस्या फॉर्म में भरें। माता जी की कृपा से सेवा-दल आपसे संपर्क करेगा।</p>
 </div>
 <div className="mt-4 p-3 rounded-lg bg-[#0B0B0E] border border-[#d4a84b]/60">
 <p className="text-[#F3EDE2] text-sm font-bold">{contactInfo.timing}</p>
 <p className="text-[#D8D2C6]/60 text-xs">सोमवार से रविवार</p>
 </div>
 </div>
 </div>
 </div>

 {/* Terms Modal */}
 {showTerms && (
 <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[#5c1a1a]/80">
 <div className="bg-red-950 border border-[#d4a84b]/60 rounded-2xl p-6 max-w-2xl max-h-[80vh] overflow-y-auto">
 <div className="flex justify-between items-center mb-4">
 <h3 className="text-xl font-bold text-[#D8D2C6]">नियम व शर्तें</h3>
 <button onClick={() => setShowTerms(false)} className="text-[#D8D2C6] hover:text-[#D8D2C6]">✕</button>
 </div>
 <div className="space-y-4 text-[#D8D2C6]/80 text-sm">
 <p><strong className="text-[#D8D2C6]">1. सेवा शर्तें:</strong> हमारी सेवाएं पारंपरिक तांत्रिक विधियों पर आधारित हैं।</p>
 <p><strong className="text-[#D8D2C6]">2. जांच दक्षिणा:</strong> संतुष्ट होने पर क्षमतानुसार दक्षिणा दें।</p>
 <p><strong className="text-[#D8D2C6]">3. गोपनीयता:</strong> आपकी जानकारी 100% गोपनीय रखी जाएगी।</p>
 <p><strong className="text-[#D8D2C6]">4. साधना अवधि:</strong> 3 दिन से 90 दिन तक समस्या के अनुसार।</p>
 <p className="text-[#F3EDE2]"><strong className="text-[#F3EDE2]">5. अघोर विधि:</strong> अघोर विधि से कार्य किया जाता है। पूरी श्रद्धा और विश्वास हो तभी संपर्क करें। जिन्हें विश्वास नहीं, कृपया दूर रहें।</p>
 <p className="text-[#F3EDE2]"><strong className="text-[#F3EDE2]">6. शुद्ध मन:</strong> छल-कपट, दुर्भाव से ना आएं - अच्छे मन से आएं ताकि कार्य सफल हो।</p>
 </div>
 </div>
 </div>
 )}

 {/* Bottom Bar */}
 <div className="border-t border-[#d4a84b]/20 mt-12 pt-8">
 <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
 <p className="text-[#D8D2C6]/60 text-sm">
 <span className="block text-2xl mb-2" style={{ fontFamily: "'Yatra One', serif", color: '#E2C170', textShadow: '0 2px 10px #000' }}>~ माता मलिहा ~</span>
 © 2024 माता मलीहा। सर्वाधिकार सुरक्षित।
 </p>
 <div className="mt-4 pt-4 max-w-3xl mx-auto space-y-2" style={{ borderTop: '1px solid rgba(201,162,58,0.2)' }}>
 <p className="text-[10px] leading-relaxed" style={{ color: '#8A857D' }}>
 This site is NOT a part of the Facebook™ website or Facebook™ Inc. Additionally, this site is NOT endorsed by Facebook™ in any way. FACEBOOK™ is a trademark of META Platforms, Inc. This site is also not affiliated with, endorsed by, or connected to Instagram™, WhatsApp™ or any other Meta™ product in any manner.
 </p>
 <p className="text-[10px] leading-relaxed" style={{ color: '#8A857D' }}>
 अस्वीकरण (Disclaimer): यह वेबसाइट आध्यात्मिक एवं धार्मिक आस्था पर आधारित सेवाएं प्रदान करती है। परिणाम व्यक्ति की श्रद्धा, कर्म एवं परिस्थिति अनुसार भिन्न हो सकते हैं। यह सेवाएं किसी चिकित्सीय, कानूनी या वित्तीय परामर्श का विकल्प नहीं हैं। केवल 18 वर्ष से अधिक आयु के व्यक्तियों के लिए। सभी दक्षिणा पूर्णतः स्वेच्छा से दी जाती है।
 </p>
 <p className="text-[10px]" style={{ color: '#8A857D' }}>
 </p>
 <p className="text-[#D8D2C6]/40 text-xs">
 Made with ❖ for spiritual guidance
 </p>
 </div>
 </div>
 </div>
 </div>

 {/* Floating Buttons */}
 <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-3">
 <button
 onClick={scrollToForm}
 className="w-14 h-14 bg-gradient-to-r from-[#d4a84b] to-[#d4a84b] rounded-full shadow-lg shadow-amber-500/30 flex items-center justify-center hover:scale-110 transition-transform"
 data-testid="floating-form-cta"
 >
 <span className="text-2xl">❖</span>
 </button>
 </div>
 </footer>
 );
};

export default UltimateFooter;
